import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PermissionItemResponse } from '../../../../../../../api';

@Component({
  selector: 'base-permission',
  templateUrl: './base-permission.component.html',
})
export class BasePermissionComponent {
  @Input() permission: PermissionItemResponse & { isSelected: boolean; priority: number };
  @Output() selectPermission = new EventEmitter<boolean>();

  onPermissionSelect(isSelected: boolean): void {
    this.selectPermission.emit(isSelected);
  }
}
